import * as O from "fp-ts/Option"
import { Option } from "fp-ts/Option"
import { VsOption } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"

import { VsCodeState } from "./machines/ecommerce-machine/e-commerce-machine-context"

export const validVsCodeValue = (vsCode: VsCodeState): string | undefined => {
    return vsCode.type == "valid" ? vsCode.value : undefined
}

export const vsMember = (vsCode: VsCodeState, vsOption: Option<VsOption>): boolean =>
    F.pipe(
        vsOption,
        O.fold(F.constFalse, () => customerIsVsMember(vsCode)),
    )

export const customerIsVsMember = (vsCode: VsCodeState): boolean =>
    vsCode.type == "valid" || (vsCode.type == "none" && vsCode.maybeVsMember)
